import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { SmallMultiple } from 'components/smallmultiple'

// import shrinkingData from 'data/shrinking.json'
// import growingData from 'data/growing.json'
// import regionsData from 'data/regions.json'
import countriesData from 'data/countries.json'
import worldData from 'data/world.json'

import countriesDataFR from 'data/countries-fr.json'
import worldDataFR from 'data/world-fr.json'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  properties = properties || {
    worldOnly: 'false',
  }
  const worldOnly = properties?.worldOnly
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {worldOnly !== 'true' && (
        <SmallMultiple
          title={
            tenant.lang === 'fr'
              ? "Évolution de la population de certains pays jusqu'en 2100"
              : 'Bevölkerungsentwicklung ausgewählter Länder bis 2100'
          }
          subtitle={
            tenant.lang === 'fr'
              ? "Prévisions de l'ONU, scénario moyen"
              : 'UNO-Prognosen, Mittleres Szenario'
          }
          data={tenant.lang === 'fr' ? countriesDataFR : countriesData}
          source={
            tenant.lang === 'fr'
              ? "Source: <a href='https://population.un.org/wpp/Graphs/DemographicProfiles'>Prévisions de l'ONU concernant la population mondiale en 2022</a>"
              : "Quelle: UNO <a href='https://population.un.org/wpp/Graphs/DemographicProfiles'>Weltbevölkerungsprognose 2022</a>"
          }
          lang={tenant.lang}
        />
      )}

      {worldOnly === 'true' && (
        <SmallMultiple
          data={tenant.lang === 'fr' ? worldDataFR : worldData}
          source={
            tenant.lang === 'fr'
              ? "Source: <a href='https://population.un.org/wpp/Graphs/DemographicProfiles'>Prévisions de l'ONU concernant la population mondiale en 2022</a>"
              : "Quelle: UNO <a href='https://population.un.org/wpp/Graphs/DemographicProfiles'>Weltbevölkerungsprognose 2022</a>"
          }
          lang={tenant.lang}
        />
      )}

      {/*
      <SmallMultiple
        title={'8 ausgewählte Länder, deren Bevölkerung abnimmt'}
        subtitle={'Prognose der Bevölkerungsentwicklung bis zum Jahr 2100'}
        data={shrinkingData}
        lang={tenant.lang}
      />

      <SmallMultiple
        title={'8 ausgewählte Länder, deren Bevölkerung zunimmt'}
        subtitle={'Prognose der Bevölkerungsentwicklung bis zum Jahr 2100'}
        data={growingData}
        lang={tenant.lang}
      />

      <SmallMultiple
        title={'Bevölkerungsentwicklung in 47 Regionen'}
        subtitle={'33 wachsend, 14 schrumpfend'}
        data={regionsData}
        lang={tenant.lang}
      />
    
      */}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  @media only screen and (max-width: 600px) {
    margin: 0 2rem 0;
  }
`
export default MainComponent
